import { Theme, makeStyles } from '@material-ui/core'

interface UsePublicWrapperStylesProps {
    bannerImgUrlRectangle: string
    bannerImgUrlRectangleRocket: string
    bannerSubmit: string
    bannerNext: string
    bannerEclipse: string
    buttonLogout: string
    bannerImgUrlWomanWorkingOnlaptop: string
    displaySecondaryOnMobile?: boolean
    bannerImageHeight: number
}

const usePublicWrapperStyles = makeStyles<Theme, UsePublicWrapperStylesProps>((theme) => {
    const mobileBreakpoint = theme.breakpoints.down('sm')
    const maxImgHeight = 'calc(48vh - 50px)'
    return {
        whiteBg: {
            backgroundColor: 'var(--white)'
        },
        imgBackground: {
            position: 'absolute',
            zIndex: 0,
            height: '100%',
            '&>img': {
                height: '100%',
                width: '100%'
            },
            left: '61%',
            [mobileBreakpoint]: {
                display: 'none',
                left: 0,
                top: '25%',
                maxWidth: '100%',
                overflow: 'hidden'
            }
        },
        root: {
            width: '100vw',
            minHeight: '100vh',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundColor: 'white',
            [mobileBreakpoint]: {
                display: 'flex',
                flexDirection: 'column',
                backgroundPosition: 'bottom right -25rem',
                // backgroundSize: 'contain'
                backgroundSize: '70.23%'
            }
        },
        contentColumn: {
            display: 'flex',
            flexDirection: 'column',
            flexBasis: '75%',
            flex: '1',
            width: '40%',
            marginTop: '-14px',
            [mobileBreakpoint]: {
                height: 'auto'
            }
        },
        imageColumn: {
            display: 'flex',
            position: 'fixed',
            flexDirection: 'column',
            maxHeight: '900px',
            [mobileBreakpoint]: {
                display: 'none'
            }
        },
        imageColumnBg: {
            display: 'none',
            [mobileBreakpoint]: {
                display: 'block',
                width: '100%',
                maxHeight: maxImgHeight,
                position: 'absolute'
            }
        },
        workingWomanImg: {
            padding: '109px 60px 0 0',
            marginLeft: '60px',
            zIndex: 1,
            [mobileBreakpoint]: {
                maxWidth: '100%',
                maxHeight: maxImgHeight,
                padding: '16px'
            }
        },
        bannerContainer: {
            padding: '0px 50px 0px 46px',
            maxWidth: '50%',
            [mobileBreakpoint]: {
                padding: '0px 24px 24px 24px'
            }
        },
        bannerTitle: {
            fontFamily: 'var(--font-family-base)',
            fontSize: 'var(--logPage-header-text-size)',
            lineHeight: '68px',
            color: 'var(--black)',
            marginTop: '0rem',
            marginBottom: '0.5rem'
        },
        header: {
            padding: '48px 0px 15px 48px',
            width: '100%',
            [mobileBreakpoint]: {
                padding: '24px 0px 15px 24px'
            }
        },
        logo: {
            width: '256px',
            height: '33px',
            display: 'block'
        },
        content: {
            paddingLeft: '5rem',
            paddingRight: '7.5rem',
            marginBottom: '6rem',
            [mobileBreakpoint]: {
                padding: '0px 24px',
                margin: '0px'
            }
        }
    }
})

export default usePublicWrapperStyles
